import {
  PrimaryButton as Primary,
  LinkButton as Link,
  SecondaryButton as Secondary,
} from "./Buttons";
export const PrimaryButton = Primary;
export const LinkButton = Link;
export const SecondaryButton = Secondary;
